module.exports = __webpack_public_path__ + "static/auto_4-96dc7898c5699927bd5821677d776313.jpg";